import { useContext } from 'react'
import { AppContext } from '../context/AppProvider'
import { usersUpdate, usersDelete } from '../actions/usersActions'
import { buildPrivateApiUrl } from '../config/api'

export const useUsers = () => {
  const { dispatch } = useContext(AppContext)
  const apiUrl = buildPrivateApiUrl('users')
  const apiApprove = buildPrivateApiUrl('approve')
  const buildRecheckUrl = (userId) => buildPrivateApiUrl(`users/${userId}/recheck-company`)

  const handleDeleteUser = async (userId) => {
    const token = localStorage.getItem('token')
    if (token) {
      try {
        deleteUser(token, userId)
      } catch (error) {
        console.error('Token handling failed:', error)
      }
    }
  }

  const handleUpdateUserProfile = async (payload) => {
    const token = localStorage.getItem('token')
    if (token) {
      try {
        return await updateUserProfile(token, payload)
      } catch (error) {
        console.error('Token handling failed:', error)
        throw error
      }
    }
    return null
  }

  const handleApproveUser = (payload) => {
    const token = localStorage.getItem('token')
    if (token) {
      try {
        handleApprove(token, payload)
      } catch (error) {
        console.error('Token handling failed:', error)
      }
    }
  }

  const handleRecheckUserCompany = async (userId) => {
    const token = localStorage.getItem('token')
    if (!token) {
      return
    }

    const response = await fetch(buildRecheckUrl(userId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${token}`
      }
    })

    if (!response.ok) {
      throw new Error(`Recheck failed (${response.status})`)
    }

    const payload = await response.json()
    dispatch(usersUpdate(payload.data))
    return payload.data
  }

  const deleteUser = async (token, userId) => {
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      try {
        const response = await fetch(apiUrl, {
          method: 'DELETE',
          headers,
          body: JSON.stringify({ data: [userId] })
        })
        if (response.ok) {
          const { data } = await response.json()
          dispatch(usersDelete(userId))
          console.log(data)
        } else {
          console.error('Error with status code:', response.status)
        }
      } catch (error) {
        console.error('Login error:', error)
      }
    }
  }

  const updateUserProfile = async (token, payload) => {
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      try {
        const response = await fetch(apiUrl, {
          method: 'PUT',
          headers,
          body: JSON.stringify({ data: [payload] })
        })
        if (response.ok) {
          const { results, data } = await response.json()
          const nextUser = data || results?.[0]?.data || payload
          dispatch(usersUpdate(nextUser))
          console.log(results)
          return nextUser
        } else {
          console.error('Error with status code:', response.status)
          throw new Error(`Update failed (${response.status})`)
        }
      } catch (error) {
        console.error('Login error:', error)
        throw error
      }
    }
    return null
  }

  const handleApprove = async (token, payload) => {
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      try {
        const response = await fetch(apiApprove, {
          method: 'POST',
          headers,
          body: JSON.stringify({ id: payload._id })
        })
        if (response.ok) {
          const { results } = await response.json()
          dispatch(usersUpdate(payload))
          console.log(results)
        } else {
          console.error('Error with status code:', response.status)
        }
      } catch (error) {
        console.error('Login error:', error)
      }
    }
  }
  return { handleDeleteUser, handleUpdateUserProfile, handleApproveUser, handleRecheckUserCompany }
}
